import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { TOTAL_ENGAGEMENT_BAR_CHART_OPTIONS } from './constants';
import { customCategories } from '../../../../utility';

const TotalEngagementSummaryChart = () => {
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch);
    const {
        isPaidSearchLoading,
        totalEngagementBarChart,
        totalEngagementByCampaignBarChart
    } = dtcData;
    const { categories, data } = totalEngagementBarChart;
    const { isCostApiLoading } = useSelector((state) => state.webMatrix);
    const isLoading = isCostApiLoading || isPaidSearchLoading;
    const isCampgain = [150].includes(company.id);
    const updatedCategories = customCategories(
        isCampgain ? totalEngagementByCampaignBarChart.categories : categories
    );
    const barChartOptions = useMemo(
        () => ({
            ...TOTAL_ENGAGEMENT_BAR_CHART_OPTIONS,
            xaxis: {
                ...TOTAL_ENGAGEMENT_BAR_CHART_OPTIONS.xaxis,
                categories: updatedCategories
            },
            plotOptions: {
                ...TOTAL_ENGAGEMENT_BAR_CHART_OPTIONS.plotOptions,
                bar: {
                    ...TOTAL_ENGAGEMENT_BAR_CHART_OPTIONS.plotOptions.bar,
                    columnWidth: updatedCategories.length > 10 ? '40%' : '50px'
                }
            }
        }),
        [categories]
    );

    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);

    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Total Engagement Summary
                </Typography>
            </Box>

            <Box className="wh-100" id="engagement-deciles">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={
                            isCampgain
                                ? totalEngagementByCampaignBarChart.data
                                : [{ name: 'Engagement', data: data }]
                        }
                        height={'300px'}
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default TotalEngagementSummaryChart;
